import React from "react";
import i18n from "../../../i18n";
import swal from "sweetalert";
import { Spinner } from "react-bootstrap";
import { getOfficerRanks, createOfficerRank } from "../../../models/officers";
import { OfficerRankRow } from "./officer_rank_row";

export class OfficerRanks extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      input: {},
      update: {},
      ranks: [],
      errors: {},
      signature: null,
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleUpdateChange = this.handleUpdateChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.loadAllRanks = this.loadAllRanks.bind(this);
  }

  componentDidMount() {
    this.loadAllRanks();
  }

  async loadAllRanks() {
    this.setState({ is_loading_ranks: true });
    const response = await getOfficerRanks("");
    let ranks = response.data;
    if (response.success) {
      this.setState({ is_loading_ranks: false });
      this.setState({ ranks: ranks });
      this.props.triggerReloadRanks();
    } else {
      this.setState({ is_loading_ranks: false });
    }
  }

  handleChange(event) {
    let input = this.state.input;
    input[event.target.name] = event.target.value;
    this.setState({ input });
  }

  handleUpdateChange(event) {
    let update = this.state.update;
    update[event.target.name] = event.target.value;
    this.setState({ update });
  }

  async handleSubmit(event) {
    event.preventDefault();
    try {
      const { input } = this.state;
      const formData = new FormData();
      formData.append("rank_en", input.rank_en);
      formData.append("rank_ar", input.rank_ar);
      const response = await createOfficerRank(formData);
      if (response.success) {
        swal(i18n.t("success"), "Rank successfully created!!", "success", {
          buttons: false,
          timer: 2000,
        });
        this.loadAllRanks();
        this.props.triggerReloadRanks();
      } else {
        let error_message = response.message;
        let resObject = response.data;
        for (const key in resObject) {
          if (Object.hasOwnProperty.call(resObject, key)) {
            let element = resObject[key];
            error_message += "\n" + element;
          }
        }
        swal("Failed", error_message, "error");
      }
    } catch (err) {
      console.log(err);
    }
  }

  render() {
    let { ranks } = this.state;
    return (
      <React.Fragment>
        <div className="row">
          <div className="col-md-8">
            {this.state.is_loading && (
              <div
                className="text-center"
                style={{ textAlign: "center", padding: "5rem" }}
              >
                <Spinner animation="border" />
              </div>
            )}

            {!this.state.is_loading && ranks.length < 1 && (
              <div>{i18n.t("no_data_found")}</div>
            )}
            {!this.state.is_loading_ranks && ranks.length > 0 && (
              <div className="table-wrapper">
                <table
                  className="table table-bordered table-hover text-nowrap"
                  style={{ width: "100%" }}
                >
                  <thead>
                    <tr>
                      <th>Rank(En)</th>
                      <th>Rank(Arabic)</th>
                      <th>{i18n.t("action")}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {ranks.map((item, i) => {
                      return (
                        <OfficerRankRow
                          key={item.id}
                          item={item}
                          triggerReloadRanks={this.loadAllRanks}
                        />
                      );
                    })}
                  </tbody>
                </table>
              </div>
            )}
          </div>
          <div className="col-md-4">
            <div className="wrapper wrapper2 border border-dark rounded-2 p-2">
              <form
                id="UpdateUser"
                className="card-body"
                tabIndex="500"
                autoComplete="off"
              >
                <div className="col-sm-12 col-md-12">
                  <h5 className="p-2">
                    {i18n.t("add_new")} {i18n.t("rank")}
                  </h5>
                </div>
                <div className="col-sm-12 col-md-12">
                  <div className="form-group">
                    <label className="form-label">{i18n.t("rank")}</label>
                    &nbsp;
                    <input
                      type="text"
                      name="rank_en"
                      value={this.state.input.rank_en}
                      onChange={this.handleChange}
                      autoComplete="rank_en"
                      className="form-control custom-input "
                    />
                    <div className="text-danger">
                      {this.state.errors.rank_en}
                    </div>
                  </div>
                </div>

                <div className="col-sm-12 col-md-12">
                  <div className="form-group">
                    <label className="form-label">
                      {i18n.t("rank")}({i18n.t("arabic")})
                    </label>
                    &nbsp;
                    <input
                      type="text"
                      name="rank_ar"
                      value={this.state.input.rank_ar}
                      onChange={this.handleChange}
                      autoComplete="rank_ar"
                      className="form-control custom-input"
                      style={{ direction: "rtl" }}
                    />
                    <div className="text-danger">
                      {this.state.errors.rank_ar}
                    </div>
                  </div>
                </div>

                <button
                  type="button"
                  className="btn btn-primary btn-block mt-5"
                  onClick={this.handleSubmit}
                >
                  {i18n.t("submit")}
                </button>
              </form>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}
